import { toast } from 'react-toastify';
import customFetch from './customFetch';

const updateOrderAndCreateCards = async (orderId, paymentIntentId) => {
  if (!orderId || !paymentIntentId) {
    toast.error('Karte konnte nicht erstellt werden!');
    return;
  }
  try {
    const response = await customFetch.patch(`/orders/${orderId}`, {
      paymentIntentId,
    });
    return response;
  } catch (error) {
    toast.error(error);
    return error;
  }
};

export default updateOrderAndCreateCards;
